import React, {ReactElement} from 'react';
import MComponent from '../Toolkit/Components/Component';
import {Column} from 'primereact/column';
import MTable, {MTableFilters} from './Toolkit/Table';
import {AuditLog} from '../Api/ControllerTypes/AuditLogTypes';
import NSwagAdapter from '../Toolkit/Api/NSwagAdapter';
import {AuditLogClient} from '../Api/AuditLogClient';
import MNSwagClientConfiguration from '../Toolkit/Api/NSwagClientConfiguration';
import TrafficManagementAccessTokenProvider from '../Api/TrafficManagementAccessTokenProvider';
import {IMsalContext} from '@azure/msal-react';
import {AuditLogMultiReply} from '../Api/ControllerTypes/AuditLogTypes';

type AuditLogRow = {
    data: AuditLog;
}

type Props = {
    parentId: string;
    msalContext: IMsalContext;
}

/** */
type State = {
    rowData: AuditLogRow[];
    filters: MTableFilters;
}

class AuditListControl extends MComponent<Props, State> {

    private readonly m_auditLogClient: NSwagAdapter<AuditLogClient>;

    public constructor(props: Props) {
        super(props);

        this.m_auditLogClient = new NSwagAdapter<AuditLogClient>(new AuditLogClient(
            new MNSwagClientConfiguration(process.env.REACT_APP_TRAFFICMANAGEMENT_API_KEY!,
                new TrafficManagementAccessTokenProvider(this.props.msalContext))));

        this.bindMethods();
        this.initializeState();
    }

    private bindMethods(): void {
        this.loadPageData = this.loadPageData.bind(this);
    }

    async componentDidUpdate() {
        await this.loadPageData();
    }

    private initializeState(): void {
        this.state = {
            filters: {},
            rowData: []
        };
    }

    private entryDateTemplate(rowData: AuditLogRow): string | undefined {
        if(rowData.data.modifiedOn !== null) {
            try {
                return rowData.data.modifiedOn!.toLocaleString();
            } catch {
                return '';
            }
        }
        return '';
    }

    private noteTemplate(rowData: AuditLogRow): ReactElement {
        return (
                <span style={{whiteSpace: 'normal'}}>
                    {rowData.data.notes}
                </span>

        );
    }

    private async loadPageData(): Promise<void> {
        //Read note data.
        const auditResult = await this.m_auditLogClient.callWithReply(
            AuditLogMultiReply, (client) => client.getAll(this.props.parentId));
        auditResult.throwIfFailed();

        const rowData = auditResult.reply!.logs.map(n => ({data: n}));

        //Only update state if data has changed.
        if(rowData.length !== this.state.rowData.length)
            this.safeSetState(draft => draft.rowData = rowData);
    }

    public render(): ReactElement {
        return (
            <React.Fragment>
                <MTable
                    rowKey="data.id"
                    rowData={this.state.rowData}
                    filters={this.state.filters}
                    showSelection={false}
                    sortField={'data.modifiedOn'}
                    sortOrder={-1}>

                    <Column field="data.modifiedOn"
                            header="Date"
                            body={this.entryDateTemplate}
                            filter={false}
                            sortable={true}
                            style={{width: '15%'}}/>
                    <Column field="data.modifiedBy"
                            header="User"
                            filter={false}
                            sortable={true}
                            style={{width: '15%'}}/>
                    <Column field="data.notes"
                            header="Action"
                            filter={false}
                            sortable={false}
                            body={this.noteTemplate}
                            style={{width: '70%'}}/>
                </MTable>
            </React.Fragment>
        );
    }
}

export default AuditListControl;